import 'bootstrap/dist/css/bootstrap.css';
import { ChangeEvent, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useLocation, useParams } from 'react-router-dom';
import Spinner from '../../shared/spinner';
import InputMask from 'react-input-mask';
import DateInput from '../../shared/dateInput';
import { format, parse, parseISO } from 'date-fns';
import { Usuario } from '../../shared/model/usuario';
import { cpf as cpfValidacao } from 'cpf-cnpj-validator';
import UsuarioService from '../../services/usuarioService';
import CustomAlert from '../../shared/customAlert';
import { Role } from '../../shared/model/role';
import { UUID } from 'crypto';
import { Matriz } from '../../shared/model/matriz';
import { OrigemUsuario } from '../../shared/model/origemUsuario';
import { useVerificaPermissao } from '../../shared/useVerificaPermissao';
import AlcadaService from '../../services/alcadaService';
import { Alcada } from '../../shared/model/alcada';
import ParametrosService from '../../services/parametrosService';

interface Origem {
    id: number;
    nome: string;
}

interface EntidadeSelecao {
    id: number;
    nome: string;
    roleId?: string;
}

function UsuarioInclusaoAlteracao() {
    useVerificaPermissao();
    const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);

    const location = useLocation();
    const { id, cadastroUsuarioPromotora } = location.state || {};
    const { tipo } = useParams();
    const [dtInclusao, setDtInclusao] = useState('');
    const [nome, setNome] = useState('');
    const [cpf, setCpf] = useState('');
    const [dtNascimento, setDtNascimento] = useState('');
    const [email, setEmail] = useState('');
    const [login, setLogin] = useState('');
    const [roles, setRoles] = useState<Role[]>([]);
    const [role, setRole] = useState<Role | null>(null);
    const [senha, setSenha] = useState('');
    const [senha2, setSenha2] = useState('');
    const [origemVinculo, setOrigemVinculo] = useState<number>(0);
    const [tipoAcesso, setTipoAcesso] = useState('');

    const [regimeRelacionamento, setRegimeRelacionamento] = useState('');

    const [availableOriginadoresComercial, setAvailableOriginadoresComercial] = useState<EntidadeSelecao[]>([]);
    const [selectedOriginadoresComercial, setSelectedOriginadoresComercial] = useState<EntidadeSelecao[]>([]);
    const [toMoveOriginadoresComercial, setToMoveOriginadoresComercial] = useState<EntidadeSelecao[]>([]);
    const [fromSelectedOriginadoresComercial, setFromSelectedOriginadoresComercial] = useState<EntidadeSelecao[]>([]);

    const moveToSelectedOriginadoresComercial = () => { const newSelected = [...selectedOriginadoresComercial, ...toMoveOriginadoresComercial]; const newAvailable = availableOriginadoresComercial.filter((p) => !toMoveOriginadoresComercial.includes(p)); setAvailableOriginadoresComercial(newAvailable); setSelectedOriginadoresComercial(newSelected); setToMoveOriginadoresComercial([]); };
    const moveToAvailableOriginadoresComercial = () => { const newAvailable = [...availableOriginadoresComercial, ...fromSelectedOriginadoresComercial]; const newSelected = selectedOriginadoresComercial.filter((p) => !fromSelectedOriginadoresComercial.includes(p)); setAvailableOriginadoresComercial(newAvailable); setSelectedOriginadoresComercial(newSelected); setFromSelectedOriginadoresComercial([]); };
    const moveAllToSelectedOriginadoresComercial = () => { const newSelected = [...selectedOriginadoresComercial, ...availableOriginadoresComercial]; setSelectedOriginadoresComercial(newSelected); setAvailableOriginadoresComercial([]); };
    const moveAllToAvailableOriginadoresComercial = () => { const newAvailable = [...availableOriginadoresComercial, ...selectedOriginadoresComercial]; setAvailableOriginadoresComercial(newAvailable); setSelectedOriginadoresComercial([]); setFromSelectedOriginadoresComercial([]); };

    const [ipUsuario, setIpUsuario] = useState('');
    const isRegional = role?.descricao?.toLowerCase() === 'regional';
    const isComercial = role?.descricao?.toLowerCase() === 'comercial';
    const isVinculoUnico = false;

    const [origensList, setOrigensList] = useState<Origem[]>([]);
    const [erroOrigemList, setErroOrigemList] = useState(false);

    const [loading, setLoading] = useState(false);

    const [availableOrigens, setAvailableOrigens] = useState<Matriz[]>([]);
    const [selectedOrigens, setSelectedOrigens] = useState<Matriz[]>([]);
    const [selectedToMoveOrigens, setSelectedToMoveOrigens] = useState<Matriz[]>([]);
    const [selectedFromSelectedOrigens, setSelectedFromSelectedOrigens] = useState<Matriz[]>([]);

    const [availablePromotoras, setAvailablePromotoras] = useState<EntidadeSelecao[]>([]);
    const [selectedPromotoras, setSelectedPromotoras] = useState<EntidadeSelecao[]>([]);
    const [selectedToMovePromotoras, setSelectedToMovePromotoras] = useState<EntidadeSelecao[]>([]);
    const [selectedFromSelectedPromotoras, setSelectedFromSelectedPromotoras] = useState<EntidadeSelecao[]>([]);

    const [alcadas, setAlcadas] = useState<Alcada[]>([]);
    const [alcada, setAlcada] = useState<Alcada | undefined | null>(null);
    const [selectedAlcadaId, setSelectedAlcadaId] = useState<number | string | null>(null);

    const [entidadesList, setEntidadesList] = useState<EntidadeSelecao[]>([]);
    const [novaEntidadeId, setNovaEntidadeId] = useState<number | string>('');
    const [usaNovaHierarquia, setUsaNovaHierarquia] = useState(false);
    const [filtroTipoEntidade, setFiltroTipoEntidade] = useState<string>('');
    
    const [usaCpfLogin, setUsaCpfLogin] = useState(false);

    const usuarioService: UsuarioService = new UsuarioService();
    const alcadaService: AlcadaService = new AlcadaService();
    const parametrosService: ParametrosService = new ParametrosService();

    const ROLES_FLEXIVEIS = [ 'Operador'];

    const moveToSelectedOrigens = () => { const newSelected = [...selectedOrigens, ...selectedToMoveOrigens]; const newAvailable = availableOrigens.filter((origem) => !selectedToMoveOrigens.includes(origem)); setAvailableOrigens(newAvailable); setSelectedOrigens(newSelected); setSelectedToMoveOrigens([]); };
    const moveToAvailableOrigens = () => { const newAvailable = [...availableOrigens, ...selectedFromSelectedOrigens]; const newSelected = selectedOrigens.filter((origem) => !selectedFromSelectedOrigens.includes(origem)); setAvailableOrigens(newAvailable); setSelectedOrigens(newSelected); setSelectedFromSelectedOrigens([]); };
    const moveAllToSelectedOrigens = () => { const newSelected = [...selectedOrigens, ...availableOrigens]; setSelectedOrigens(newSelected); setAvailableOrigens([]); };
    const moveAllToAvailableOrigens = () => { const newAvailable = [...availableOrigens, ...selectedOrigens]; setAvailableOrigens(newAvailable); setSelectedOrigens([]); };
    const moveToSelectedPromotoras = () => { const newSelected = [...selectedPromotoras, ...selectedToMovePromotoras]; const newAvailable = availablePromotoras.filter((p) => !selectedToMovePromotoras.includes(p)); setAvailablePromotoras(newAvailable); setSelectedPromotoras(newSelected); setSelectedToMovePromotoras([]); };
    const moveToAvailablePromotoras = () => { const newAvailable = [...availablePromotoras, ...selectedFromSelectedPromotoras]; const newSelected = selectedPromotoras.filter((p) => !selectedFromSelectedPromotoras.includes(p)); setAvailablePromotoras(newAvailable); setSelectedPromotoras(newSelected); setSelectedFromSelectedPromotoras([]); };
    const moveAllToSelectedPromotoras = () => { const newSelected = [...selectedPromotoras, ...availablePromotoras]; setSelectedPromotoras(newSelected); setAvailablePromotoras([]); };
    const moveAllToAvailablePromotoras = () => { const newAvailable = [...availablePromotoras, ...selectedPromotoras]; setAvailablePromotoras(newAvailable); setSelectedPromotoras([]); setSelectedFromSelectedPromotoras([]); };

    const handleSelectionComercial = (origemClicada: Origem) => {
        const isSelected = selectedOrigens.some(o => o.id === origemClicada.id);
        if (isSelected) {
            setSelectedOrigens([]);
        } else {
            setSelectedOrigens([origemClicada as unknown as Matriz]);
        }
    };

    const requisitosSenha = {
        comprimento: senha.length >= 8,
        letraMaiuscula: /[A-Z]/.test(senha),
        letraMinuscula: /[a-z]/.test(senha),
        numero: /\d/.test(senha),
        caracterEspecial: /[@$!%*?&]/.test(senha),
    };

    const todosRequisitosAtendidos = Object.values(requisitosSenha).every((val) => val);

    useEffect(() => {
        const fetchPromotorasCascata = async () => {
            if (isRegional && selectedOrigens.length > 0) {
                try {
                    setLoading(true);
                    const idsOriginadores = selectedOrigens.map(o => o.id!);
                    const currentUserId = id ? Number(id) : 0;
                    const response = await usuarioService.listarPromotorasPorOriginadores(idsOriginadores, currentUserId);

                    const todasPromotoras = response.data;

                    const disponiveis = todasPromotoras.filter((p: EntidadeSelecao) =>
                        !selectedPromotoras.some(sel => sel.id === p.id)
                    );

                    setAvailablePromotoras(disponiveis);
                } catch (error) {
                    console.error("Erro ao buscar promotoras", error);
                    setAlert({ message: 'Erro ao carregar promotoras vinculadas.', type: 'error' });
                } finally {
                    setLoading(false);
                }
            } else {
                setAvailablePromotoras([]);
            }
        };

        fetchPromotorasCascata();
    }, [selectedOrigens, role]);


    const listarTodasAlcadas = async (role: string | undefined) => {
        try {
            setLoading(true);
            let acesso = role === 'INTERNO' ? 'I' : 'E';
            setTipoAcesso(acesso);
            const responseList = await alcadaService.listarAlcadaPorTipoAcesso(acesso);
            setAlcadas(responseList.data);
            setLoading(false);
        } catch (err) {
            setLoading(false);
            console.error(err);
        }
    };

    const handleAlcadaSelectChange = (value: string): void => {
        let newSelectedId: number | string | null;
        if (value === '') newSelectedId = null;
        else if (!isNaN(Number(value))) newSelectedId = Number(value);
        else newSelectedId = value;
        try {
            const alcadaNova = alcadas.find((item) => item.id === newSelectedId)
            setAlcada(alcadaNova);
        } catch (err) {
            setLoading(false);
            console.error(err);
        }
        setSelectedAlcadaId(newSelectedId);
    };

    const listarEntidadesFlexiveis = async () => {
        setLoading(true);
        try {
            const response = await usuarioService.listarEntidadesParaSelecao();
            setEntidadesList(response.data);
        } catch (err: any) {
            setAlert({ message: 'Erro ao listar entidades hierárquicas', type: 'error' });
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const listarUsuarioPorId = async () => {
        setLoading(true);
        try {
            const response = await usuarioService.listarUsuarioComOrigemPorId(id);
            const json = response.data[0].usuario;
            setDtInclusao(json.dtInclusao ? format(parseISO(json.dtInclusao), 'dd/MM/yyyy HH:mm:ss') : '');
            setNome(json.nome);
            setCpf(json.cpf);
            setDtNascimento(json.dtNascimento ? format(parseISO(json.dtNascimento), 'dd/MM/yyyy') : '');
            setEmail(json.email);
            setRole(json.role);
            setLogin(json.login);
            setIpUsuario(json.ipUsuario || '');
            setRegimeRelacionamento(json.regimeRelacionamento || '');
            setSelectedAlcadaId(json.alcada?.id);
            setAlcada(json.alcada);
            listarTodasAlcadas(json.role?.tipoAcesso);

            if (json.role && ROLES_FLEXIVEIS.includes(json.role.descricao)) {
                setUsaNovaHierarquia(true);
                await listarEntidadesFlexiveis();

            } else {
                setUsaNovaHierarquia(false);

                const vinculosDoBanco = response.data
                    .filter((o: any) => o.idOrigem !== null && o.idOrigem !== undefined)
                    .map((o: { idOrigem: number; nomeOrigem: string }) => ({
                        id: o.idOrigem,
                        nome: o.nomeOrigem
                    }));

                if (json.role?.descricao.toLowerCase() === 'regional') {
                    try {
                        const todasRoles = await usuarioService.listarRoles();
                        const roleOriginador = todasRoles.data.find((r: Role) => r.descricao.toLowerCase().includes('originador'));

                        if (roleOriginador) {
                            const resOriginadores = await usuarioService.listarOrigensPorRole(roleOriginador.id);

                            const todosOriginadoresIds = resOriginadores.data.map((o: any) => String(o.id));

                            const apenasOriginadores = vinculosDoBanco.filter((v: any) => todosOriginadoresIds.includes(String(v.id)));
                            const apenasPromotoras = vinculosDoBanco.filter((v: any) => !todosOriginadoresIds.includes(String(v.id)));

                            setSelectedOrigens(apenasOriginadores);
                            setSelectedPromotoras(apenasPromotoras as EntidadeSelecao[]);
                        } else {
                            setSelectedOrigens(vinculosDoBanco);
                        }
                    } catch (e) {
                        console.error("Erro ao separar originadores", e);
                        setSelectedOrigens(vinculosDoBanco);
                    }
                }
                else

                    if (vinculosDoBanco.length > 0) {
                        if (json.role?.descricao.toLowerCase() !== 'regional' && json.role?.descricao.toLowerCase() !== 'comercial') {
                            setSelectedOrigens(vinculosDoBanco);
                            setOrigemVinculo(vinculosDoBanco[0].id);
                        }
                    }

                if (json.role?.id) {
                    let idRoleBusca = json.role.id;
                    if (json.role.descricao.toLowerCase() === 'regional') {
                        try {
                            const responseRolesAux = await usuarioService.listarRoles();
                            const roleOriginador = responseRolesAux.data.find((r: Role) => r.descricao.toLowerCase().includes('originador'));
                            if (roleOriginador) idRoleBusca = roleOriginador.id;
                        } catch (e) { console.error(e); }
                    }
                    else if (json.role.descricao.toLowerCase() === 'comercial') {
                        try {
                            const responseRolesAux = await usuarioService.listarRoles();
                            const roleOriginador = responseRolesAux.data.find((r: Role) => r.descricao.toLowerCase().includes('originador'));
                            if (roleOriginador) idRoleBusca = roleOriginador.id;
                        } catch (e) { console.error(e); }
                    }

                    const responseRole = await usuarioService.listarOrigensPorRole(idRoleBusca);

                    if (responseRole.data.length !== 0) {
                        setOrigensList(responseRole.data);

                        const disponiveis = responseRole.data.filter((origem: { id: number }) =>
                            !response.data.some((o: { idOrigem: number }) => String(o.idOrigem) === String(origem.id))
                        );

                        setAvailableOrigens(disponiveis);
                    }
                }
            }
            setLoading(false);
        } catch (err: any) {
            setLoading(false);
            setAlert({ message: err.response?.data || 'Erro ao carregar usuário', type: 'error' });
            console.error(err);
        }
    };

    const limparCampos = () => {
        setNome('');
        setCpf('');
        setDtNascimento('');
        setEmail('');
        setRole(null);
        setLogin('');
        setSenha('');
        setSenha2('');
        setIpUsuario('');
        setRegimeRelacionamento('');
        setAlcada(null);
        setSelectedAlcadaId(null);
        setOrigensList([]);
        setSelectedOrigens([]);
        setAvailableOrigens([]);
        setAvailablePromotoras([]); setSelectedPromotoras([]);
        setAvailableOriginadoresComercial([]); setSelectedOriginadoresComercial([]);
        setNovaEntidadeId('');
        setFiltroTipoEntidade('');
        setUsaNovaHierarquia(false);
    };

    const handleSubmit = async (event: any) => {
        event.preventDefault();
        if (!cpfValidacao.isValid(cpf)) return setAlert({ message: 'CPF Inválido', type: 'warning' });
        let emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailRegex.test(email) === false) return setAlert({ message: 'E-mail Inválido', type: 'warning' });
        if (senha !== senha2) return setAlert({ message: 'As senhas devem ser iguais!', type: 'warning' });
        if (senha !== '' && !todosRequisitosAtendidos) { setAlert({ message: 'A senha nova não atende a todos os requisitos.', type: 'warning' }); return; }
        if (usaNovaHierarquia && !novaEntidadeId) return setAlert({ message: 'É obrigatório selecionar um vínculo para este perfil.', type: 'warning' });

        let usuario: any = new Usuario();
        usuario.id = id;
        usuario.nome = nome;
        usuario.cpf = cpf;
        usuario.dtNascimento = parse(dtNascimento, 'dd/MM/yyyy', new Date());
        usuario.email = email;
        usuario.role = role!;
        usuario.login = login;
        usuario.senhaString = senha;
        usuario.alcada = alcada!;
        usuario.ipUsuario = ipUsuario;
        usuario.regimeRelacionamento = regimeRelacionamento;

        let origemUsuario: any = new OrigemUsuario();
        origemUsuario.usuario = usuario;

        if (usaNovaHierarquia) {
            origemUsuario.novaEntidadeId = Number(novaEntidadeId);
            origemUsuario.idsOrigens = [];
        } else {
            if (isRegional) {
                const idsOriginadores = selectedOrigens.map(o => o.id!);
                const idsPromotoras = selectedPromotoras.map(p => p.id!);
                origemUsuario.idsOrigens = [...idsOriginadores, ...idsPromotoras];
            }
            else if (isRegional || isComercial) {
                const idsOriginadores = selectedOrigens.map(o => o.id!);
                const idsPromotoras = selectedPromotoras.map(p => p.id!);
                origemUsuario.idsOrigens = [...idsOriginadores, ...idsPromotoras];
            }
            else {
                if (origensList.length > 0) origemUsuario.idsOrigens = selectedOrigens.map((origem) => origem.id!);
            }
        }

        try {
            await usuarioService.incluirAlterarUsuario(origemUsuario);
            setLoading(false);
            setAlert({ message: tipo === 'inclusao' ? 'Usuário salvo com sucesso!' : 'Usuário alterado com sucesso!', type: 'success' });
        } catch (err: any) {
            setLoading(false);
            setAlert({ message: err.response?.data || 'Erro ao salvar', type: 'error' });
            console.error(err);
        }
    };

    const handleRoleChange = (e: ChangeEvent<HTMLSelectElement>) => {
        const selectedRoleId = e.target.value;
        const selectedRole = roles.find((item) => item.id === selectedRoleId as UUID);

        setRole(selectedRole!);
        setAvailablePromotoras([]); setSelectedPromotoras([]);
        setSelectedOrigens([]); setAvailableOrigens([]);
        setAvailableOriginadoresComercial([]); setSelectedOriginadoresComercial([]);

        if (selectedRole) {
            listarTodasAlcadas(selectedRole.tipoAcesso);

            if (ROLES_FLEXIVEIS.includes(selectedRole.descricao)) {
                setUsaNovaHierarquia(true);
                listarEntidadesFlexiveis();
                setOrigensList([]); setSelectedOrigens([]); setAvailableOrigens([]);
            } else {
                setUsaNovaHierarquia(false);
                setNovaEntidadeId('');
                setFiltroTipoEntidade('');

                if (selectedRole.descricao.toLowerCase() === 'regional') {
                    const roleOriginador = roles.find(r => r.descricao.toLowerCase().includes('originador'));
                    if (roleOriginador) listarOrigensPorRole(roleOriginador);
                    else listarOrigensPorRole(selectedRole);

                } else if (selectedRole.descricao.toLowerCase() === 'comercial') {
                    console.log("Selecionou Comercial - Buscando Originadores...");
                    const roleOriginador = roles.find(r => r.descricao.toLowerCase().includes('originador'));
                    if (roleOriginador) {
                        listarOrigensPorRole(roleOriginador);
                    } else {
                        listarOrigensPorRole(selectedRole);
                    }


                } else {
                    listarOrigensPorRole(selectedRole);
                }
            }
        }
    };

    const listarOrigensPorRole = async (role: Role, origemPreSelecionada?: EntidadeSelecao) => {
        setOrigensList([]); setOrigemVinculo(0); setAvailableOrigens([]); setSelectedOrigens([]);
        try {
            setLoading(true);
            const response = await usuarioService.listarOrigensPorRole(role.id);
            if (response.data.length !== 0) {
                setOrigensList(response.data);
                setOrigemVinculo(response.data[0].id!);

                if (origemPreSelecionada?.id) {
                    const origemSelecionada = response.data.find((origem: { id: number }) =>
                        String(origem.id) === String(origemPreSelecionada.id)
                    ) || origemPreSelecionada;

                    setOrigemVinculo(Number(origemSelecionada.id));
                    setSelectedOrigens([origemSelecionada as unknown as Matriz]);
                    setAvailableOrigens(response.data.filter((origem: { id: number }) =>
                        String(origem.id) !== String(origemSelecionada.id)
                    ));
                } else {
                    setAvailableOrigens(response.data);
                }
            }
            setErroOrigemList(false);
            return response.data;
        } catch (err: any) {
            setErroOrigemList(true);
            setAlert({ message: err.response?.data || 'Erro ao listar origens', type: 'error' });
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const obterRolePromotoraParaCadastro = (rolesRetornadas: Role[]) => {
        const descricao = (roleItem: Role) => roleItem.descricao?.toLowerCase();
        const descricaoOrigem = (roleItem: Role) => roleItem.roleOrigem?.descricao?.toLowerCase();

        return rolesRetornadas.find((roleItem) => descricao(roleItem) === 'promotora master')
            || rolesRetornadas.find((roleItem) => descricaoOrigem(roleItem) === 'promotora master')
            || rolesRetornadas.find((roleItem) => descricao(roleItem) === 'promotora')
            || rolesRetornadas.find((roleItem) => descricaoOrigem(roleItem) === 'promotora');
    };

    const listarRoles = async () => {
        try {
            const response = await usuarioService.listarRolesAtivas();
            const rolesRetornadas = response.data;
            setRoles(rolesRetornadas);

            if (tipo === 'inclusao' && cadastroUsuarioPromotora?.promotoraId) {
                const rolePromotora = obterRolePromotoraParaCadastro(rolesRetornadas);

                if (!rolePromotora) {
                    setAlert({
                        message: 'Promotora salva, mas não foi possível selecionar automaticamente o tipo de usuário Promotora.',
                        type: 'warning'
                    });
                    return;
                }

                setRole(rolePromotora);
                setAvailablePromotoras([]);
                setSelectedPromotoras([]);
                setAvailableOriginadoresComercial([]);
                setSelectedOriginadoresComercial([]);
                setUsaNovaHierarquia(false);
                setNovaEntidadeId('');
                setFiltroTipoEntidade('');
                listarTodasAlcadas(rolePromotora.tipoAcesso);

                await listarOrigensPorRole(rolePromotora, {
                    id: Number(cadastroUsuarioPromotora.promotoraId),
                    nome: cadastroUsuarioPromotora.promotoraNome || 'Promotora cadastrada'
                });
            }
        } catch (err: any) {
            console.error(err);
        }
    };

    const carregarParametros = async () => {
        try {
            const response = await parametrosService.listarTodosParametros();
            const dados = response.data;
            const parametro = Array.isArray(dados) ? dados[0] : dados;
            const valorLoginCpf = (parametro as any).login_cpf;

            if (Number(valorLoginCpf) === 1) {
                setUsaCpfLogin(true);
            } else {
                setUsaCpfLogin(false);
            }
        } catch (error) {
            console.error("Erro ao carregar parâmetros", error);
        }
    }

    useEffect(() => {
        if (tipo === 'alteracao') {
            listarUsuarioPorId();
        }
        listarRoles();
        carregarParametros();
    }, []);

    function capitalizeFirstLetter(str: string) {
        return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
    };

    return (
        <div className="container">
            {alert && (<CustomAlert message={alert.message} type={alert.type} onClose={() => { setAlert(null); if (alert.type === 'success') { window.history.back(); } }} />)}
            {loading ? <Spinner loading={loading} /> : (
                <form onSubmit={handleSubmit}>
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                            {tipo === 'inclusao' ? <h5>Usuário &gt; Cadastro</h5> : <h5>Usuário &gt; Alteração</h5>}
                            <Button id="App-button-cor-principal" onClick={() => window.history.back()}>Voltar</Button>
                        </div>
                        <hr className="my-4" />
                    </div>

                    <div className="row" style={{ marginTop: '20px' }}>
                        {tipo === 'alteracao' ? (
                            <>
                                <div className="col-md-1"><label>Código</label><input readOnly type="text" className="form-control" value={id} style={{ backgroundColor: 'LightGrey' }} /></div>
                                <div className="col-md-2"><label>Data Criação</label><input readOnly type="text" className="form-control" value={dtInclusao} style={{ backgroundColor: 'LightGrey' }} /></div>
                            </>
                        ) : null}
                        <div className="col-xl"><label>Nome Completo <span style={{ color: 'red' }}>*</span></label><input required type="text" className="form-control" value={nome} onChange={(e) => setNome(e.target.value)} /></div>
                        <div className="col-xl">
                            <div className="form-group">
                                <label>CPF <span style={{ color: 'red' }}>*</span></label>
                                <InputMask required mask="999.999.999-99" type="text" className="form-control" value={cpf!} onChange={(e) => {
                                    const valorDigitado = e.target.value;
                                    setCpf(valorDigitado);
                                    if (usaCpfLogin && tipo === 'inclusao') {
                                        const cpfLimpo = valorDigitado.replace(/[^0-9]/g, '');
                                        setLogin(cpfLimpo);
                                    }
                                }} />
                            </div>
                        </div>
                        <div className="col-xl"><label>Data Nascimento <span style={{ color: 'red' }}>*</span></label><DateInput required className="form-control" type="text" value={dtNascimento} onChange={(e) => setDtNascimento((e.target.value).replace(/_/g, ""))} /></div>
                    </div>

                    <div className="row">
                        <div className="col-md-3"><label>E-mail <span style={{ color: 'red' }}>*</span></label><input required type="text" className="form-control" value={email} onChange={(e) => setEmail(e.target.value)} /></div>
                        <div className="col-md-3"><label>Tipo de Usuário <span style={{ color: "red" }}>*</span></label><select required className="form-select" value={role?.id || ""} onChange={handleRoleChange}><option value="" disabled>Selecione um tipo de usuário</option>{roles.map((item) => (<option key={item.id} value={item.id}>{item.descricao}</option>))}</select></div>
                        <div className="col-md-2"><label>Tipo de Acesso</label><input type="text" className="form-control" value={role?.tipoAcesso || ''} readOnly style={{ backgroundColor: 'LightGrey' }} /></div>
                        <div className="col-md-2" style={{ marginTop: '0px' }}>
                            <label htmlFor="alcadaSelect">Alçada Esteira</label>
                            <select
                                id="alcadaSelect"
                                className="form-select"
                                disabled={isRegional || isComercial}
                                value={selectedAlcadaId === null ? '' : selectedAlcadaId}
                                onChange={(e) => { handleAlcadaSelectChange(e.target.value); }}
                            >
                                <option value="">Selecione...</option>
                                {alcadas.map((alcada) => (
                                    <option key={alcada.id !== null ? alcada.id : `null-${alcada.nomeAlcada}`} value={alcada.id !== null ? alcada.id : ''}>{alcada.nomeAlcada}</option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-2">
                            <label>IPs / Faixas de IP</label>
                            <textarea rows={2} placeholder="Ex: 192.168.0.1, 192.168.0.0/24" className="form-control" value={ipUsuario} onChange={(e) => setIpUsuario(e.target.value)} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-2">
                            <label>Regime de Relacionamento</label>
                            <select className="form-select" value={regimeRelacionamento} onChange={(e) => setRegimeRelacionamento(e.target.value)}>
                                <option value="">Selecione...</option>
                                <option value="CLT">CLT</option>
                                <option value="Prestador de Serviço">Prestador de Serviço</option>
                            </select>
                        </div>
                    </div>

                    {!usaNovaHierarquia && !isVinculoUnico && (
                        origensList.length > 0 ? (
                            <div style={{ display: 'flex', marginTop: '20px', flexDirection: 'column' }}>
                                <div style={{ display: 'flex' }}>
                                    <div><h6>{capitalizeFirstLetter(
                                        role?.descricao.toLowerCase() === 'supervisor' ? 'Supervisores' : 
                                        role?.descricao.toLowerCase() === 'regional' ? 'Originadores' :
                                            role?.descricao.toLowerCase() === 'comercial' ? 'Originadores' :
                                                (role?.descricao.toUpperCase() === 'PROMOTORA MASTER' ? 'Promotoras Master' :
                                                    role?.descricao.toUpperCase() === 'PONTO DE VENDA' ? 'Pontos de Venda' :
                                                        role?.descricao.toUpperCase() + 'es')
                                    )} Disponíveis</h6><select multiple value={selectedToMoveOrigens.map((m) => m.id!.toString())} onChange={(e) => { const options = e.target.options; const selected = []; for (let i = 0; i < options.length; i++) { if (options[i].selected) { const origem = availableOrigens.find(o => o.id!.toString() === options[i].value); if (origem) selected.push(origem); } } setSelectedToMoveOrigens(selected); }} style={{ width: '575px', height: '250px' }}>{availableOrigens.map((origem) => (<option key={origem.id} value={origem.id!.toString()}>{origem.id} - {origem.nome!}</option>))}</select></div>
                                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}><button type="button" onClick={moveToSelectedOrigens} style={{ margin: '5px' }}>{'>'}</button><button type="button" onClick={moveAllToSelectedOrigens} style={{ margin: '5px' }}>{'>>'}</button><button type="button" onClick={moveToAvailableOrigens} style={{ margin: '5px' }}>{'<'}</button><button type="button" onClick={moveAllToAvailableOrigens} style={{ margin: '5px' }}>{'<<'}</button></div>
                                    <div><h6>Selecionados</h6><select multiple value={selectedFromSelectedOrigens.map((p) => p.id!.toString())} onChange={(e) => { const options = e.target.options; const selected = []; for (let i = 0; i < options.length; i++) { if (options[i].selected) { const origem = selectedOrigens.find(p => p.id!.toString() === options[i].value); if (origem) selected.push(origem); } } setSelectedFromSelectedOrigens(selected); }} style={{ width: '575px', height: '250px' }}>{selectedOrigens.map((origem) => (<option key={origem.id} value={origem.id!.toString()}>{origem.id} - {origem.nome!}</option>))}</select></div>
                                </div>
                            </div>
                        ) : null
                    )}

                    {isRegional && selectedOrigens.length > 0 && (
                        <div style={{ display: 'flex', marginTop: '20px', flexDirection: 'column' }}>
                            <hr className="my-4" />
                            <h6>Vínculo de Promotoras</h6>
                            <div style={{ display: 'flex' }}>
                                <div><h6>Promotoras Disponíveis</h6><select multiple value={selectedToMovePromotoras.map((m) => m.id!.toString())} onChange={(e) => { const options = e.target.options; const selected = []; for (let i = 0; i < options.length; i++) { if (options[i].selected) { const p = availablePromotoras.find(o => o.id!.toString() === options[i].value); if (p) selected.push(p); } } setSelectedToMovePromotoras(selected); }} style={{ width: '575px', height: '250px' }}>{availablePromotoras.map((p) => (<option key={p.id} value={p.id!.toString()}>{p.id} - {p.nome!}</option>))}</select></div>
                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}><button type="button" onClick={moveToSelectedPromotoras} style={{ margin: '5px' }}>{'>'}</button><button type="button" onClick={moveAllToSelectedPromotoras} style={{ margin: '5px' }}>{'>>'}</button><button type="button" onClick={moveToAvailablePromotoras} style={{ margin: '5px' }}>{'<'}</button><button type="button" onClick={moveAllToAvailablePromotoras} style={{ margin: '5px' }}>{'<<'}</button></div>
                                <div><h6>Promotoras Selecionadas</h6><select multiple value={selectedFromSelectedPromotoras.map((p) => p.id!.toString())} onChange={(e) => { const options = e.target.options; const selected = []; for (let i = 0; i < options.length; i++) { if (options[i].selected) { const p = selectedPromotoras.find(o => o.id!.toString() === options[i].value); if (p) selected.push(p); } } setSelectedFromSelectedPromotoras(selected); }} style={{ width: '575px', height: '250px' }}>{selectedPromotoras.map((p) => (<option key={p.id} value={p.id!.toString()}>{p.id} - {p.nome!}</option>))}</select></div>
                            </div>
                        </div>
                    )}

                    {!usaNovaHierarquia && isVinculoUnico && (
                        <div className="row" style={{ marginTop: '20px' }}>
                            <div className="col-md-6">
                                <h6>Selecione o Comercial (Vínculo Único)</h6>
                                {origensList.length > 0 ? (
                                    <div className="card" style={{ height: '250px', overflowY: 'auto', padding: '10px' }}>
                                        {origensList.map((origem) => (
                                            <div key={origem.id} className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id={`chk-origem-${origem.id}`}
                                                    checked={selectedOrigens.some(s => s.id === origem.id)}
                                                    onChange={() => handleSelectionComercial(origem)}
                                                />
                                                <label className="form-check-label" htmlFor={`chk-origem-${origem.id}`}>
                                                    {origem.id} - {origem.nome}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="alert alert-warning">
                                        Nenhum vínculo encontrado para Comercial. Verifique o cadastro.
                                    </div>
                                )}
                                <small className="text-muted">Para este perfil, apenas uma seleção é permitida.</small>
                            </div>
                        </div>
                    )}

                    {tipo === 'alteracao' ? (
                        <div className="row" style={{ marginTop: '20px' }}>
                            <div className="col-xl"><label>Login</label><input type="text" className="form-control" value={login} readOnly style={{ backgroundColor: 'LightGrey' }} /></div>
                            <div className="col-xl"><label>Senha </label><input type="password" className="form-control" value={senha} onChange={(e) => setSenha(e.target.value)} /></div>
                            <div className="col-xl"><label>Confirmação Senha</label><input type="password" className="form-control" value={senha2} onChange={(e) => setSenha2(e.target.value)} /></div>
                        </div>
                    ) : (
                        <div className="row" style={{ marginTop: '20px' }}>
                            <div className="col-xl"><label>Login <span style={{ color: 'red' }}>*</span></label>
                                <input
                                    required
                                    type="text"
                                    className="form-control"
                                    value={login}
                                    readOnly={usaCpfLogin}
                                    style={usaCpfLogin ? { backgroundColor: 'LightGrey' } : {}}
                                    onChange={(e) => {
                                        if (!usaCpfLogin) {
                                            setLogin(e.target.value);
                                        }
                                    }}
                                />
                            </div>
                            <div className="col-xl"><label>Senha <span style={{ color: 'red' }}>*</span></label><input required type="password" className="form-control" value={senha} onChange={(e) => setSenha(e.target.value)} /></div>
                            <div className="col-xl"><label>Confirmação Senha <span style={{ color: 'red' }}>*</span></label><input required type="password" className="form-control" value={senha2} onChange={(e) => setSenha2(e.target.value)} /></div>
                        </div>
                    )}

                    <div style={{ justifyContent: 'center', display: 'flex' }}>
                        {tipo === 'inclusao' || senha !== '' ? (
                            <ul style={{ marginTop: '10px', padding: 0 }}><span style={{ fontWeight: 'bold' }}>Características da Senha: </span><li style={{ color: requisitosSenha.comprimento ? 'green' : 'red' }}>Pelo menos 8 digitos</li><li style={{ color: requisitosSenha.letraMaiuscula ? 'green' : 'red' }}>Pelo menos 1 letra maiúscula</li><li style={{ color: requisitosSenha.letraMinuscula ? 'green' : 'red' }}>Pelo menos 1 letra minúscula</li><li style={{ color: requisitosSenha.numero ? 'green' : 'red' }}>Pelo menos 1 número</li><li style={{ color: requisitosSenha.caracterEspecial ? 'green' : 'red' }}>Pelo menos 1 caractere especial (@$!%*?&)</li></ul>
                        ) : (null)}
                    </div>

                    <div>
                        <hr className="my-4" />
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            {tipo === 'inclusao' ? (<button onClick={limparCampos} className="w-40 btn btn-lg" id="App-button-cor-principal" type="button">Limpar Campos</button>) : (<div></div>)}
                            <button className="w-40 btn btn-success btn-lg" type="submit">{tipo !== 'inclusao' ? 'Alterar Usuário' : 'Salvar Usuário'}</button>
                        </div>
                    </div>
                </form>
            )}
        </div >
    );
}

export default UsuarioInclusaoAlteracao;
